export enum FilterItemType {
  Property = 'property',
  Group = 'group',
  ValueType = 'valueType',
  DatabaseItemId = 'databaseItemId',
}
